import React, { useState, useEffect } from 'react';
import '../../styles/CreateCounsellor.css';
import { createCounsellor, getAllCounsellor, updateCounsellor, getTaskSummaryCounsellorWise, deleteCounsellor } from '../../services/getAdminApi';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';

const CreateCounsellor = () => {
    const [users, setUsers] = useState([]);
    const [taskSummary, setTaskSummary] = useState({}); 
    const [showModal, setShowModal] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [phone, setPhone] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [passwordVisibility, setPasswordVisibility] = useState({});
    const [isEditingPassword, setIsEditingPassword] = useState({});
    const [updatedPassword, setUpdatedPassword] = useState({});

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const response = await getAllCounsellor();
            const data = response.data.data;
            setUsers(data);
           
            // Fetch tasks for each counsellor
            data.forEach((user) => {
                fetchTaskSummary(user.id);
            });
        } catch (error) {
            console.error("Error fetching users", error);
        }
    };

    const fetchTaskSummary = async (counsellorId) => {
        try {
            const response = await getTaskSummaryCounsellorWise(counsellorId);
            const tasks = response.data.data.reduce((acc, task) => {
                acc[task.task_status] = task.count;
                return acc;
            }, {});
            setTaskSummary((prev) => ({ ...prev, [counsellorId]: tasks }));
        } catch (error) {
            console.error("Error fetching task summary", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError("Passwords do not match!");
            return;
        }
        try {
            const newUser = { name, email, password, phone };
            const response = await createCounsellor(newUser);
            const data = response.data.data;
            setUsers([...users, data]);
            setShowModal(false);
            resetForm();
        } catch (error) {
            console.error("Error creating user", error);
        }
    };

    const resetForm = () => {
        setName("");
        setEmail("");
        setPassword("");
        setConfirmPassword("");
        setError("");
    };

    const enablePasswordEdit = (userId) => {
        setIsEditingPassword((prevState) => ({
            ...prevState,
            [userId]: true,
        }));
    };

    const handlePasswordChange = (userId, newPassword) => {
        setUpdatedPassword((prevState) => ({
            ...prevState,
            [userId]: newPassword,
        }));
    };

    const handleUpdatePassword = async (userId, name, email, phone) => {
        const newPassword = updatedPassword[userId];
        if (!newPassword) {
            Swal.fire("Error", "Password cannot be empty", "error");
            return;
        }
        if (newPassword.length < 6) {
            Swal.fire("Error", "Enter at least six characters", "error");
            return;
        }
        try {
            await updateCounsellor(userId, { password: newPassword }).then((res) => {
                if (res.status === 200) {
                    Swal.fire("Success", "Password updated successfully!", "success");
                }
            });

            // Disable password editing after update
            setIsEditingPassword((prevState) => ({
                ...prevState,
                [userId]: false,
            }));
        } catch (error) {
            Swal.fire("Error", "Failed to update password", "error");
        }
    };

    const handleDelete= async (id,name)=>{
         const confirmEdit = await Swal.fire({
                            title: 'Are you sure?',
                            text: `Do you really want to delete ${name} counsellor?`,
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Yes, delete it!',
                        });

                        if(confirmEdit.isConfirmed){
                            await deleteCounsellor(id).then((res)=>{
                               
                                if(res.status === 200){
                                     Swal.fire('Success', 'Counsellor deleted Sucessfully!', 'success');
                                     fetchUsers()
                                }
                            })
                        }
    }

    return (
        <>
            <div>
                {/* Modal for creating a new user */}
                {showModal && (
                    <div className="modal-overlay">
                        <div className="modal-container">
                            <h2>Create New User</h2>
                            <form onSubmit={handleSubmit} className="modal-form">
                                <div className="form-group">
                                    <label htmlFor="name">Name:</label>
                                    <input
                                        type="text"
                                        id="name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email">Email:</label>
                                    <input
                                        type="email"
                                        id="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="phone">Mobile No:</label>
                                    <input
                                        type="text"
                                        id="phone"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="password">Password:</label>
                                    <input
                                        type="password"
                                        id="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="confirmPassword">Confirm Password:</label>
                                    <input
                                        type="password"
                                        id="confirmPassword"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        required
                                    />
                                </div>
                                {error && <p className="error">{error}</p>}
                                <button type="submit" className="btn-submit">Submit</button>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowModal(false)}
                                >
                                    Cancel
                                </button>
                            </form>
                        </div>
                    </div>
                )}

                {/* Counsellors List */}
                <div className="manage-counsellor-head-div">
                    <div className="dashboard-heading-div">
                        <p>Manage Counsellors</p>
                    </div>
                    <button className='create-counsellor-btn' onClick={() => setShowModal(true)}><i className="bx bx-plus"></i>Create Counsellor</button>
                </div>

                <div className="hold-all-cards-container">
                    {users.length > 0 ? (
                        users.map((user) => {
                            const tasks = taskSummary[user.id] || {};
                            return (
                                <div className="counsellor-card-container" key={user.id}>
                                    <div className="card">
                                        <div className="img">
                                            <img
                                                className="counsellor-img"
                                                src="https://images.unsplash.com/photo-1610216705422-caa3fcb6d158?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NDB8fGZhY2V8ZW58MHwyfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                                                alt="Counsellor"
                                            />
                                        </div>
                                        <div className="infos">
                                            <div className="name">
                                                <h2>{user.name}</h2>
                                                <h4>{user.email}</h4>
                                                <h4>{user.phone}</h4>
                                            </div>
                                            <div className="counsellor-text">
                                                <input
                                                    type={passwordVisibility[user.id] ? "text" : "password"}
                                                    value={isEditingPassword[user.id] ? updatedPassword[user.id] || "" : user.password} // Display new value if editing, else show masked password
                                                    onChange={(e) => handlePasswordChange(user.id, e.target.value)}
                                                    disabled={!isEditingPassword[user.id]} // Enable/disable based on editing state
                                                />
                                                <i
                                                    className='bx bxs-edit'
                                                    onClick={() => enablePasswordEdit(user.id)}
                                                ></i>
                                                <i class='bx bxs-trash-alt' onClick={()=> handleDelete(user.id, user.name)}></i>

                                                {isEditingPassword[user.id] && (
                                                    <button
                                                        onClick={() => handleUpdatePassword(user.id, user.name, user.email, user.phone)}
                                                        className="btn-update"
                                                    >
                                                        Update
                                                    </button>
                                                )}
                                            </div>

                                            <div className="task-summary">
                                                <ul className="stats">
                                                    <li>
                                                        <h3>{tasks["To do"] || 0}</h3>
                                                        <h4>Pending</h4>
                                                    </li>
                                                    <li>
                                                        <h3>{tasks["In progress"] || 0}</h3>
                                                        <h4>In Progress</h4>
                                                    </li>
                                                    <li>
                                                        <h3>{tasks["Done"] || 0}</h3>
                                                        <h4>Completed</h4>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="links">
                                                <Link to={`/dashboard/assign-task/${user.id}`}>
                                                    <button className="view">View Tasks</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        "Loading"
                    )}
                </div>
            </div>
        </>
    );
};

export default CreateCounsellor;
